import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import axios from 'axios';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';


function UserGridDropdown({ onChangeDropdown, modelName, required, selectedValue, showLabel, autoFocus, onBlur, openMenuOnFocus, isDisable }) {
    const [selectedUsersOption, setSelectedUsersOption] = useState([]);
    const [getUsersOptions, setUsersOptions] = useState([]);
    
    function handleChange(e, actionMeta) {
        setSelectedUsersOption(e);
        onChangeDropdown(e, actionMeta);
    };

    const fetchUsers = async () => {
        try {
            let statusDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + "/userlist", {params: statusDetails});
            if (response.status === 200) {
                setUsersDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setUsersDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.Id, label: p.FullName, name: 'AssignedTo', description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setUsersOptions(allModuleOpt);
        setSelectedUsersOption(allModuleOpt.filter(x => x.value === selectedValue));
    }

    useEffect(() => {
        fetchUsers();
    }, []);
    return (
        <>
            <Select
                className="GridDropdown"
                name={modelName}
                value={selectedUsersOption ? selectedUsersOption : []}
                isClearable
                options={getUsersOptions || [] }
                onChange={handleChange}
                onBlur={onBlur}
                autoFocus={autoFocus}
                openMenuOnFocus={openMenuOnFocus}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: 32,
                      height: 32,
                      fontSize: '0.85rem',
                      borderColor: state.isFocused ? '#2684FF' : '#ccc',
                      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
                      '&:hover': {
                        borderColor: '#2684FF',
                      },
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      height: 32,
                      padding: '0 8px',
                    }),
                    input: (base) => ({
                      ...base,
                      margin: 0,
                      padding: 0,
                    }),
                    indicatorsContainer: (base) => ({
                      ...base,
                      height: 32,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999, // make sure dropdown appears above modals/tables
                    }),
                  }}
                />
        </>
    )
}

export default UserGridDropdown